const tierMessages = {
    testModeIsUnavailable: 'Test mode is unavailable in a free plan. Please upgrade your plan to "Paid"',
    environmentIsUnavailable: (env) => `${env} environment is unavailable in a free plan. Please upgrade your plan to "Paid"`,
};

export default tierMessages;